import React, { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import clsx from "clsx";
import { Grid } from "@mui/material";
import { CLUB_INBODY_ROUTER } from "@icoach/router/routerPath";
import { Card, Form, Button, Stack, Box, MenuItem, SelectField } from "@curves/ui-base";
import useInBodyApi from "@apis/useInBodyApi";
import { refIsRequiredError, isEqual } from "@util/utils";
import { FieldByEmployee, FieldByMember } from "@icoach/inbody/components/";
import { useInBodyContext } from "@icoach/inbody/components/InBodyContext";
import useGetInbodyOverviewOptionsState from "@util/hook/useGetInbodyOverviewOptionsState";
import { IN_BODY_INTERVIEW_TABS, MEASURE_REFERENCE_TYPE } from "@icoach/constants/";

const InBodyHistorySearchBar = ({ className }) => {
	const { referenceID, referenceType: referenceTypeParams } = useParams();
	const { setSourceData, setShowContent } = useInBodyContext();
	const { getSearchHistoryApi } = useInBodyApi();
	const history = useHistory();
	const [isLock, setLock] = useState(false);
	const [referenceType, setReferenceType] = useState(referenceTypeParams || MEASURE_REFERENCE_TYPE.MEMBER);
	const { options: referenceTypeOptions, hasEmployeeMeasure } = useGetInbodyOverviewOptionsState();
	const referenceTypeRef = useRef(null);
	const referenceIDRef = useRef(null);
	const isEmployeeSelected = isEqual(referenceType, MEASURE_REFERENCE_TYPE.EMPLOYEE);

	const getAllParams = () => {
		return {
			type: referenceType,
			...referenceIDRef.current.getResult(),
		};
	};

	const isError = () => refIsRequiredError(referenceIDRef, referenceTypeRef);

	const handleSearchOnClick = () => {
		if (!isError()) {
			const params = getAllParams();
			doSearchApi(params);
		}
	};

	// 開始面談
	const handleInterviewOnClick = () => {
		if (!isError()) {
			const { referenceID: refID } = referenceIDRef.current.getResult();
			if (isEqual(referenceType, MEASURE_REFERENCE_TYPE.MEMBER)) {
				history.push(CLUB_INBODY_ROUTER.GET_INTERVIEW_PATH(IN_BODY_INTERVIEW_TABS.SUMMARY, refID));
			} else if (isEqual(referenceType, MEASURE_REFERENCE_TYPE.EMPLOYEE)) {
				history.push(CLUB_INBODY_ROUTER.GET_EMPLOYEE_INTERVIEW_PATH(IN_BODY_INTERVIEW_TABS.COMPARE, refID));
			}
		}
	};

	const redirectToInBodyRecord = params => {
		const { referenceType, referenceID } = params;
		let path;
		if (referenceType && referenceID) path = CLUB_INBODY_ROUTER.GET_HISTORY_PATH(referenceType, referenceID);
		else if (referenceType) path = CLUB_INBODY_ROUTER.GET_HISTORY_REFERENCETYPE_PAGE(referenceType);
		else path = CLUB_INBODY_ROUTER.HISTORY;
		history.replace(path);
	};

	const handleResetSearch = () => {
		setLock(false);
		referenceIDRef.current.initialize();
		redirectToInBodyRecord({ referenceType });
		setShowContent(false);
		setSourceData([]);
	};

	const doSearchApi = async params => {
		const { referenceID, type } = params;
		const resp = await getSearchHistoryApi(params);
		setSourceData(resp);
		setShowContent(true);
		if (referenceID) {
			redirectToInBodyRecord({
				referenceType: type,
				referenceID,
			});
		}
		setLock(true);
	};

	const handleChangeReferenceType = (_e, _dom, value) => {
		history.replace(CLUB_INBODY_ROUTER.GET_HISTORY_REFERENCETYPE_PAGE(value));
		setReferenceType(value);
	};

	useEffect(
		() => {
			if (isEqual(referenceTypeParams, referenceType)) {
				const { referenceID } = referenceIDRef.current.getResult();
				redirectToInBodyRecord({ referenceType, referenceID });
			}
		},
		// eslint-disable-next-line
		[referenceType]
	);

	return (
		<Card className={clsx("search-bar", className)}>
			<Card.CardContent>
				<Form onSubmit={handleSearchOnClick}>
					<Box className="px-4 py-3">
						<Grid container spacing={2}>
							{hasEmployeeMeasure ? (
								<React.Fragment>
									<Grid xs={3} item>
										<SelectField
											key={referenceType}
											ref={referenceTypeRef}
											label="對象"
											defaultValue={referenceType}
											onChange={handleChangeReferenceType}
											fullWidth
											disabled={isLock}
											required
										>
											{Array.isArray(referenceTypeOptions) &&
												referenceTypeOptions
													.filter(item => item || !item.disabled)
													.map(item => (
														<MenuItem key={item.value} value={item.value}>
															{item.text}
														</MenuItem>
													))}
										</SelectField>
									</Grid>
									<Grid item xs={5}>
										{isEmployeeSelected ? (
											<FieldByEmployee key={isLock.toString()} ref={referenceIDRef} referenceID={referenceID} isLock={isLock} />
										) : (
											<FieldByMember key={isLock.toString()} ref={referenceIDRef} referenceID={referenceID} isLock={isLock} />
										)}
									</Grid>
								</React.Fragment>
							) : (
								<Grid item xs={8}>
									<FieldByMember key={referenceID} ref={referenceIDRef} referenceID={referenceID} isLock={isLock} />
								</Grid>
							)}

							<Grid item xs={4}>
								<Box className="mt-4">
									{isLock ? (
										<Button name="reset" color="secondary" variant="contained" onClick={handleResetSearch}>
											重設
										</Button>
									) : (
										<Stack spacing={2}>
											{!isEmployeeSelected && (
												<Button type="submit" color="secondary" variant="outlined">
													查詢歷史
												</Button>
											)}
											<Button onClick={handleInterviewOnClick} color="secondary" variant="contained">
												開始面談
											</Button>
										</Stack>
									)}
								</Box>
							</Grid>
						</Grid>
					</Box>
				</Form>
			</Card.CardContent>
		</Card>
	);
};

export default InBodyHistorySearchBar;
